import * as ambassadorWixRestaurantsCatalogsV3Catalog from './restaurants-catalogs-v3-catalog-catalogs.http.js';
import * as ambassadorWixRestaurantsCatalogsV3CatalogTypes from './restaurants-catalogs-v3-catalog-catalogs.types.js';
import * as ambassadorWixRestaurantsCatalogsV3CatalogUniversalTypes from './restaurants-catalogs-v3-catalog-catalogs.universal.js';

export type __PublicMethodMetaInfo<
  K = string,
  M = unknown,
  T = unknown,
  S = unknown,
  Q = unknown,
  R = unknown
> = {
  getUrl: (context: any) => string;
  httpMethod: K;
  path: string;
  pathParams: M;
  __requestType: T;
  __originalRequestType: S;
  __responseType: Q;
  __originalResponseType: R;
};

export function listCatalogs(): __PublicMethodMetaInfo<
  'GET',
  {},
  ambassadorWixRestaurantsCatalogsV3CatalogUniversalTypes.ListCatalogsRequest,
  ambassadorWixRestaurantsCatalogsV3CatalogTypes.ListCatalogsRequest,
  ambassadorWixRestaurantsCatalogsV3CatalogUniversalTypes.ListCatalogsResponse,
  ambassadorWixRestaurantsCatalogsV3CatalogTypes.ListCatalogsResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixRestaurantsCatalogsV3Catalog.listCatalogs(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'GET',
    path: '/v3/catalogs',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function getMenu(): __PublicMethodMetaInfo<
  'GET',
  { catalogId: string; menuId: string },
  ambassadorWixRestaurantsCatalogsV3CatalogUniversalTypes.GetMenuRequest,
  ambassadorWixRestaurantsCatalogsV3CatalogTypes.GetMenuRequest,
  ambassadorWixRestaurantsCatalogsV3CatalogUniversalTypes.GetMenuResponse,
  ambassadorWixRestaurantsCatalogsV3CatalogTypes.GetMenuResponse
> {
  const payload = { catalogId: ':catalogId', menuId: ':menuId' } as any;

  const getRequestOptions =
    ambassadorWixRestaurantsCatalogsV3Catalog.getMenu(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'GET',
    path: '/v3/catalogs/{catalogId}/menus/{menuId}',
    pathParams: { catalogId: 'catalogId', menuId: 'menuId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function getSection(): __PublicMethodMetaInfo<
  'GET',
  { catalogId: string; menuId: string; sectionId: string },
  ambassadorWixRestaurantsCatalogsV3CatalogUniversalTypes.GetSectionRequest,
  ambassadorWixRestaurantsCatalogsV3CatalogTypes.GetSectionRequest,
  ambassadorWixRestaurantsCatalogsV3CatalogUniversalTypes.GetSectionResponse,
  ambassadorWixRestaurantsCatalogsV3CatalogTypes.GetSectionResponse
> {
  const payload = {
    catalogId: ':catalogId',
    menuId: ':menuId',
    sectionId: ':sectionId',
  } as any;

  const getRequestOptions =
    ambassadorWixRestaurantsCatalogsV3Catalog.getSection(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'GET',
    path: '/v3/catalogs/{catalogId}/menus/{menuId}/sections/{sectionId}',
    pathParams: {
      catalogId: 'catalogId',
      menuId: 'menuId',
      sectionId: 'sectionId',
    },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function updateMenu(): __PublicMethodMetaInfo<
  'PATCH',
  { catalogId: string; menuId: string },
  ambassadorWixRestaurantsCatalogsV3CatalogUniversalTypes.UpdateMenuRequest,
  ambassadorWixRestaurantsCatalogsV3CatalogTypes.UpdateMenuRequest,
  ambassadorWixRestaurantsCatalogsV3CatalogUniversalTypes.UpdateMenuResponse,
  ambassadorWixRestaurantsCatalogsV3CatalogTypes.UpdateMenuResponse
> {
  const payload = { catalogId: ':catalogId', menu: { id: ':menuId' } } as any;

  const getRequestOptions =
    ambassadorWixRestaurantsCatalogsV3Catalog.updateMenu(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'PATCH',
    path: '/v3/catalogs/{catalogId}/menus/{menu.id}',
    pathParams: { catalogId: 'catalogId', menuId: 'menuId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function updateSection(): __PublicMethodMetaInfo<
  'PATCH',
  { catalogId: string; menuId: string; sectionId: string },
  ambassadorWixRestaurantsCatalogsV3CatalogUniversalTypes.V3UpdateSectionRequest,
  ambassadorWixRestaurantsCatalogsV3CatalogTypes.V3UpdateSectionRequest,
  ambassadorWixRestaurantsCatalogsV3CatalogUniversalTypes.UpdateSectionResponse,
  ambassadorWixRestaurantsCatalogsV3CatalogTypes.UpdateSectionResponse
> {
  const payload = {
    catalogId: ':catalogId',
    menuId: ':menuId',
    section: { id: ':sectionId' },
  } as any;

  const getRequestOptions =
    ambassadorWixRestaurantsCatalogsV3Catalog.updateSection(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'PATCH',
    path: '/v3/catalogs/{catalogId}/menus/{menuId}/sections/{section.id}',
    pathParams: {
      catalogId: 'catalogId',
      menuId: 'menuId',
      sectionId: 'sectionId',
    },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function listMenus(): __PublicMethodMetaInfo<
  'GET',
  { catalogId: string },
  ambassadorWixRestaurantsCatalogsV3CatalogUniversalTypes.ListMenusRequest,
  ambassadorWixRestaurantsCatalogsV3CatalogTypes.ListMenusRequest,
  ambassadorWixRestaurantsCatalogsV3CatalogUniversalTypes.ListMenusResponse,
  ambassadorWixRestaurantsCatalogsV3CatalogTypes.ListMenusResponse
> {
  const payload = { catalogId: ':catalogId' } as any;

  const getRequestOptions =
    ambassadorWixRestaurantsCatalogsV3Catalog.listMenus(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'GET',
    path: '/v3/catalogs/{catalogId}/menus',
    pathParams: { catalogId: 'catalogId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function listSections(): __PublicMethodMetaInfo<
  'GET',
  { catalogId: string },
  ambassadorWixRestaurantsCatalogsV3CatalogUniversalTypes.ListSectionsRequest,
  ambassadorWixRestaurantsCatalogsV3CatalogTypes.ListSectionsRequest,
  ambassadorWixRestaurantsCatalogsV3CatalogUniversalTypes.ListSectionsResponse,
  ambassadorWixRestaurantsCatalogsV3CatalogTypes.ListSectionsResponse
> {
  const payload = { catalogId: ':catalogId' } as any;

  const getRequestOptions =
    ambassadorWixRestaurantsCatalogsV3Catalog.listSections(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'GET',
    path: '/v3/catalogs/{catalogId}/sections',
    pathParams: { catalogId: 'catalogId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function createMenu(): __PublicMethodMetaInfo<
  'POST',
  { catalogId: string },
  ambassadorWixRestaurantsCatalogsV3CatalogUniversalTypes.CreateMenuRequest,
  ambassadorWixRestaurantsCatalogsV3CatalogTypes.CreateMenuRequest,
  ambassadorWixRestaurantsCatalogsV3CatalogUniversalTypes.CreateMenuResponse,
  ambassadorWixRestaurantsCatalogsV3CatalogTypes.CreateMenuResponse
> {
  const payload = { catalogId: ':catalogId' } as any;

  const getRequestOptions =
    ambassadorWixRestaurantsCatalogsV3Catalog.createMenu(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v3/catalogs/{catalogId}/menus',
    pathParams: { catalogId: 'catalogId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function archiveMenu(): __PublicMethodMetaInfo<
  'POST',
  { catalogId: string; menuId: string },
  ambassadorWixRestaurantsCatalogsV3CatalogUniversalTypes.ArchiveMenuRequest,
  ambassadorWixRestaurantsCatalogsV3CatalogTypes.ArchiveMenuRequest,
  ambassadorWixRestaurantsCatalogsV3CatalogUniversalTypes.ArchiveMenuResponse,
  ambassadorWixRestaurantsCatalogsV3CatalogTypes.ArchiveMenuResponse
> {
  const payload = { catalogId: ':catalogId', menuId: ':menuId' } as any;

  const getRequestOptions =
    ambassadorWixRestaurantsCatalogsV3Catalog.archiveMenu(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v3/catalogs/{catalogId}/menus/{menuId}/archive',
    pathParams: { catalogId: 'catalogId', menuId: 'menuId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function unarchiveMenu(): __PublicMethodMetaInfo<
  'POST',
  { catalogId: string; menuId: string },
  ambassadorWixRestaurantsCatalogsV3CatalogUniversalTypes.UnarchiveMenuRequest,
  ambassadorWixRestaurantsCatalogsV3CatalogTypes.UnarchiveMenuRequest,
  ambassadorWixRestaurantsCatalogsV3CatalogUniversalTypes.UnarchiveMenuResponse,
  ambassadorWixRestaurantsCatalogsV3CatalogTypes.UnarchiveMenuResponse
> {
  const payload = { catalogId: ':catalogId', menuId: ':menuId' } as any;

  const getRequestOptions =
    ambassadorWixRestaurantsCatalogsV3Catalog.unarchiveMenu(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v3/catalogs/{catalogId}/menus/{menuId}/unarchive',
    pathParams: { catalogId: 'catalogId', menuId: 'menuId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function createSection(): __PublicMethodMetaInfo<
  'POST',
  { catalogId: string; menuId: string },
  ambassadorWixRestaurantsCatalogsV3CatalogUniversalTypes.V3CreateSectionRequest,
  ambassadorWixRestaurantsCatalogsV3CatalogTypes.V3CreateSectionRequest,
  ambassadorWixRestaurantsCatalogsV3CatalogUniversalTypes.CreateSectionResponse,
  ambassadorWixRestaurantsCatalogsV3CatalogTypes.CreateSectionResponse
> {
  const payload = { catalogId: ':catalogId', menuId: ':menuId' } as any;

  const getRequestOptions =
    ambassadorWixRestaurantsCatalogsV3Catalog.createSection(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v3/catalogs/{catalogId}/menus/{menuId}/sections',
    pathParams: { catalogId: 'catalogId', menuId: 'menuId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function getItem(): __PublicMethodMetaInfo<
  'GET',
  { catalogId: string; itemId: string },
  ambassadorWixRestaurantsCatalogsV3CatalogUniversalTypes.GetItemRequest,
  ambassadorWixRestaurantsCatalogsV3CatalogTypes.GetItemRequest,
  ambassadorWixRestaurantsCatalogsV3CatalogUniversalTypes.GetItemResponse,
  ambassadorWixRestaurantsCatalogsV3CatalogTypes.GetItemResponse
> {
  const payload = { catalogId: ':catalogId', itemId: ':itemId' } as any;

  const getRequestOptions =
    ambassadorWixRestaurantsCatalogsV3Catalog.getItem(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'GET',
    path: '/v3/catalogs/{catalogId}/items/{itemId}',
    pathParams: { catalogId: 'catalogId', itemId: 'itemId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function listItems(): __PublicMethodMetaInfo<
  'GET',
  { catalogId: string },
  ambassadorWixRestaurantsCatalogsV3CatalogUniversalTypes.ListItemsRequest,
  ambassadorWixRestaurantsCatalogsV3CatalogTypes.ListItemsRequest,
  ambassadorWixRestaurantsCatalogsV3CatalogUniversalTypes.ListItemsResponse,
  ambassadorWixRestaurantsCatalogsV3CatalogTypes.ListItemsResponse
> {
  const payload = { catalogId: ':catalogId' } as any;

  const getRequestOptions =
    ambassadorWixRestaurantsCatalogsV3Catalog.listItems(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'GET',
    path: '/v3/catalogs/{catalogId}/items',
    pathParams: { catalogId: 'catalogId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function updateItem(): __PublicMethodMetaInfo<
  'PATCH',
  { catalogId: string; itemId: string },
  ambassadorWixRestaurantsCatalogsV3CatalogUniversalTypes.UpdateItemRequest,
  ambassadorWixRestaurantsCatalogsV3CatalogTypes.UpdateItemRequest,
  ambassadorWixRestaurantsCatalogsV3CatalogUniversalTypes.UpdateItemResponse,
  ambassadorWixRestaurantsCatalogsV3CatalogTypes.UpdateItemResponse
> {
  const payload = { catalogId: ':catalogId', item: { id: ':itemId' } } as any;

  const getRequestOptions =
    ambassadorWixRestaurantsCatalogsV3Catalog.updateItem(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'PATCH',
    path: '/v3/catalogs/{catalogId}/items/{item.id}',
    pathParams: { catalogId: 'catalogId', itemId: 'itemId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function createDish(): __PublicMethodMetaInfo<
  'POST',
  { catalogId: string; menuId: string; sectionId: string },
  ambassadorWixRestaurantsCatalogsV3CatalogUniversalTypes.V3CreateDishRequest,
  ambassadorWixRestaurantsCatalogsV3CatalogTypes.V3CreateDishRequest,
  ambassadorWixRestaurantsCatalogsV3CatalogUniversalTypes.CreateDishResponse,
  ambassadorWixRestaurantsCatalogsV3CatalogTypes.CreateDishResponse
> {
  const payload = {
    catalogId: ':catalogId',
    menuId: ':menuId',
    sectionId: ':sectionId',
  } as any;

  const getRequestOptions =
    ambassadorWixRestaurantsCatalogsV3Catalog.createDish(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v3/catalogs/{catalogId}/menus/{menuId}/sections/{sectionId}/items',
    pathParams: {
      catalogId: 'catalogId',
      menuId: 'menuId',
      sectionId: 'sectionId',
    },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function createVariation(): __PublicMethodMetaInfo<
  'POST',
  { catalogId: string },
  ambassadorWixRestaurantsCatalogsV3CatalogUniversalTypes.CreateVariationRequest,
  ambassadorWixRestaurantsCatalogsV3CatalogTypes.CreateVariationRequest,
  ambassadorWixRestaurantsCatalogsV3CatalogUniversalTypes.CreateVariationResponse,
  ambassadorWixRestaurantsCatalogsV3CatalogTypes.CreateVariationResponse
> {
  const payload = { catalogId: ':catalogId' } as any;

  const getRequestOptions =
    ambassadorWixRestaurantsCatalogsV3Catalog.createVariation(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v3/catalogs/{catalogId}/variations',
    pathParams: { catalogId: 'catalogId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function createDraftCatalog(): __PublicMethodMetaInfo<
  'POST',
  { catalogId: string },
  ambassadorWixRestaurantsCatalogsV3CatalogUniversalTypes.CreateDraftCatalogRequest,
  ambassadorWixRestaurantsCatalogsV3CatalogTypes.CreateDraftCatalogRequest,
  ambassadorWixRestaurantsCatalogsV3CatalogUniversalTypes.CreateDraftCatalogResponse,
  ambassadorWixRestaurantsCatalogsV3CatalogTypes.CreateDraftCatalogResponse
> {
  const payload = { catalogId: ':catalogId' } as any;

  const getRequestOptions =
    ambassadorWixRestaurantsCatalogsV3Catalog.createDraftCatalog(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v3/draft-catalogs/{catalogId}/create',
    pathParams: { catalogId: 'catalogId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function publishDraftCatalog(): __PublicMethodMetaInfo<
  'POST',
  { catalogId: string },
  ambassadorWixRestaurantsCatalogsV3CatalogUniversalTypes.PublishDraftCatalogRequest,
  ambassadorWixRestaurantsCatalogsV3CatalogTypes.PublishDraftCatalogRequest,
  ambassadorWixRestaurantsCatalogsV3CatalogUniversalTypes.PublishDraftCatalogResponse,
  ambassadorWixRestaurantsCatalogsV3CatalogTypes.PublishDraftCatalogResponse
> {
  const payload = { catalogId: ':catalogId' } as any;

  const getRequestOptions =
    ambassadorWixRestaurantsCatalogsV3Catalog.publishDraftCatalog(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v3/draft-catalogs/{catalogId}/publish',
    pathParams: { catalogId: 'catalogId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function discardDraftCatalog(): __PublicMethodMetaInfo<
  'DELETE',
  { catalogId: string },
  ambassadorWixRestaurantsCatalogsV3CatalogUniversalTypes.DiscardDraftCatalogRequest,
  ambassadorWixRestaurantsCatalogsV3CatalogTypes.DiscardDraftCatalogRequest,
  ambassadorWixRestaurantsCatalogsV3CatalogUniversalTypes.DiscardDraftCatalogResponse,
  ambassadorWixRestaurantsCatalogsV3CatalogTypes.DiscardDraftCatalogResponse
> {
  const payload = { catalogId: ':catalogId' } as any;

  const getRequestOptions =
    ambassadorWixRestaurantsCatalogsV3Catalog.discardDraftCatalog(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'DELETE',
    path: '/v3/draft-catalogs/{catalogId}/discard',
    pathParams: { catalogId: 'catalogId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function bulkCreateVariations(): __PublicMethodMetaInfo<
  'POST',
  { catalogId: string },
  ambassadorWixRestaurantsCatalogsV3CatalogUniversalTypes.BulkCreateVariationsRequest,
  ambassadorWixRestaurantsCatalogsV3CatalogTypes.BulkCreateVariationsRequest,
  ambassadorWixRestaurantsCatalogsV3CatalogUniversalTypes.BulkCreateVariationsResponse,
  ambassadorWixRestaurantsCatalogsV3CatalogTypes.BulkCreateVariationsResponse
> {
  const payload = { catalogId: ':catalogId' } as any;

  const getRequestOptions =
    ambassadorWixRestaurantsCatalogsV3Catalog.bulkCreateVariations(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v3/draft-catalogs/{catalogId}/bulk/variations/create',
    pathParams: { catalogId: 'catalogId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function bulkUpdateItems(): __PublicMethodMetaInfo<
  'POST',
  { catalogId: string },
  ambassadorWixRestaurantsCatalogsV3CatalogUniversalTypes.BulkUpdateItemsRequest,
  ambassadorWixRestaurantsCatalogsV3CatalogTypes.BulkUpdateItemsRequest,
  ambassadorWixRestaurantsCatalogsV3CatalogUniversalTypes.BulkUpdateItemsResponse,
  ambassadorWixRestaurantsCatalogsV3CatalogTypes.BulkUpdateItemsResponse
> {
  const payload = { catalogId: ':catalogId' } as any;

  const getRequestOptions =
    ambassadorWixRestaurantsCatalogsV3Catalog.bulkUpdateItems(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v3/draft-catalogs/{catalogId}/bulk/items/update',
    pathParams: { catalogId: 'catalogId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function bulkCreateDishes(): __PublicMethodMetaInfo<
  'POST',
  { catalogId: string },
  ambassadorWixRestaurantsCatalogsV3CatalogUniversalTypes.BulkCreateDishesRequest,
  ambassadorWixRestaurantsCatalogsV3CatalogTypes.BulkCreateDishesRequest,
  ambassadorWixRestaurantsCatalogsV3CatalogUniversalTypes.BulkCreateDishesResponse,
  ambassadorWixRestaurantsCatalogsV3CatalogTypes.BulkCreateDishesResponse
> {
  const payload = { catalogId: ':catalogId' } as any;

  const getRequestOptions =
    ambassadorWixRestaurantsCatalogsV3Catalog.bulkCreateDishes(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v3/draft-catalogs/{catalogId}/bulk/dishes/create',
    pathParams: { catalogId: 'catalogId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function bulkCreateMenus(): __PublicMethodMetaInfo<
  'POST',
  { catalogId: string },
  ambassadorWixRestaurantsCatalogsV3CatalogUniversalTypes.BulkCreateMenusRequest,
  ambassadorWixRestaurantsCatalogsV3CatalogTypes.BulkCreateMenusRequest,
  ambassadorWixRestaurantsCatalogsV3CatalogUniversalTypes.BulkCreateMenusResponse,
  ambassadorWixRestaurantsCatalogsV3CatalogTypes.BulkCreateMenusResponse
> {
  const payload = { catalogId: ':catalogId' } as any;

  const getRequestOptions =
    ambassadorWixRestaurantsCatalogsV3Catalog.bulkCreateMenus(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v3/draft-catalogs/{catalogId}/bulk/menus/create',
    pathParams: { catalogId: 'catalogId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function bulkUpdateMenus(): __PublicMethodMetaInfo<
  'POST',
  { catalogId: string },
  ambassadorWixRestaurantsCatalogsV3CatalogUniversalTypes.BulkUpdateMenusRequest,
  ambassadorWixRestaurantsCatalogsV3CatalogTypes.BulkUpdateMenusRequest,
  ambassadorWixRestaurantsCatalogsV3CatalogUniversalTypes.BulkUpdateMenusResponse,
  ambassadorWixRestaurantsCatalogsV3CatalogTypes.BulkUpdateMenusResponse
> {
  const payload = { catalogId: ':catalogId' } as any;

  const getRequestOptions =
    ambassadorWixRestaurantsCatalogsV3Catalog.bulkUpdateMenus(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v3/draft-catalogs/{catalogId}/bulk/menus/update',
    pathParams: { catalogId: 'catalogId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function bulkCreateSections(): __PublicMethodMetaInfo<
  'POST',
  { catalogId: string },
  ambassadorWixRestaurantsCatalogsV3CatalogUniversalTypes.BulkCreateSectionsRequest,
  ambassadorWixRestaurantsCatalogsV3CatalogTypes.BulkCreateSectionsRequest,
  ambassadorWixRestaurantsCatalogsV3CatalogUniversalTypes.BulkCreateSectionsResponse,
  ambassadorWixRestaurantsCatalogsV3CatalogTypes.BulkCreateSectionsResponse
> {
  const payload = { catalogId: ':catalogId' } as any;

  const getRequestOptions =
    ambassadorWixRestaurantsCatalogsV3Catalog.bulkCreateSections(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v3/draft-catalogs/{catalogId}/bulk/sections/create',
    pathParams: { catalogId: 'catalogId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function bulkUpdateSections(): __PublicMethodMetaInfo<
  'POST',
  { catalogId: string },
  ambassadorWixRestaurantsCatalogsV3CatalogUniversalTypes.BulkUpdateSectionsRequest,
  ambassadorWixRestaurantsCatalogsV3CatalogTypes.BulkUpdateSectionsRequest,
  ambassadorWixRestaurantsCatalogsV3CatalogUniversalTypes.BulkUpdateSectionsResponse,
  ambassadorWixRestaurantsCatalogsV3CatalogTypes.BulkUpdateSectionsResponse
> {
  const payload = { catalogId: ':catalogId' } as any;

  const getRequestOptions =
    ambassadorWixRestaurantsCatalogsV3Catalog.bulkUpdateSections(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v3/draft-catalogs/{catalogId}/bulk/sections/update',
    pathParams: { catalogId: 'catalogId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function bulkArchiveMenus(): __PublicMethodMetaInfo<
  'POST',
  { catalogId: string },
  ambassadorWixRestaurantsCatalogsV3CatalogUniversalTypes.BulkArchiveMenusRequest,
  ambassadorWixRestaurantsCatalogsV3CatalogTypes.BulkArchiveMenusRequest,
  ambassadorWixRestaurantsCatalogsV3CatalogUniversalTypes.BulkArchiveMenusResponse,
  ambassadorWixRestaurantsCatalogsV3CatalogTypes.BulkArchiveMenusResponse
> {
  const payload = { catalogId: ':catalogId' } as any;

  const getRequestOptions =
    ambassadorWixRestaurantsCatalogsV3Catalog.bulkArchiveMenus(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v3/draft-catalogs/{catalogId}/bulk/menus/archive',
    pathParams: { catalogId: 'catalogId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function bulkUnarchiveMenus(): __PublicMethodMetaInfo<
  'POST',
  { catalogId: string },
  ambassadorWixRestaurantsCatalogsV3CatalogUniversalTypes.BulkUnarchiveMenusRequest,
  ambassadorWixRestaurantsCatalogsV3CatalogTypes.BulkUnarchiveMenusRequest,
  ambassadorWixRestaurantsCatalogsV3CatalogUniversalTypes.BulkUnarchiveMenusResponse,
  ambassadorWixRestaurantsCatalogsV3CatalogTypes.BulkUnarchiveMenusResponse
> {
  const payload = { catalogId: ':catalogId' } as any;

  const getRequestOptions =
    ambassadorWixRestaurantsCatalogsV3Catalog.bulkUnarchiveMenus(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v3/draft-catalogs/{catalogId}/bulk/menus/unarchive',
    pathParams: { catalogId: 'catalogId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export {
  Catalog as CatalogOriginal,
  InvalidateCache as InvalidateCacheOriginal,
  InvalidateCacheGetByOneOf as InvalidateCacheGetByOneOfOriginal,
  App as AppOriginal,
  Page as PageOriginal,
  URI as URIOriginal,
  File as FileOriginal,
  CustomTag as CustomTagOriginal,
  Pages as PagesOriginal,
  URIs as URIsOriginal,
  CatalogUpdated as CatalogUpdatedOriginal,
  Item as ItemOriginal,
  Money as MoneyOriginal,
  Labels as LabelsOriginal,
  VisibilityCriteria as VisibilityCriteriaOriginal,
  FulfillmentType as FulfillmentTypeOriginal,
  FulfillmentTypeWithLiterals as FulfillmentTypeWithLiteralsOriginal,
  Platform as PlatformOriginal,
  PlatformWithLiterals as PlatformWithLiteralsOriginal,
  Availability as AvailabilityOriginal,
  TimePeriod as TimePeriodOriginal,
  DayOfWeek as DayOfWeekOriginal,
  DayOfWeekWithLiterals as DayOfWeekWithLiteralsOriginal,
  SpecialHourPeriod as SpecialHourPeriodOriginal,
  DishOptions as DishOptionsOriginal,
  DishOption as DishOptionOriginal,
  DishOptionMethodOneOf as DishOptionMethodOneOfOriginal,
  DishOptionItem as DishOptionItemOriginal,
  Selection as SelectionOriginal,
  Extras as ExtrasOriginal,
  Deselection as DeselectionOriginal,
  Type as TypeOriginal,
  TypeWithLiterals as TypeWithLiteralsOriginal,
  ItemType as ItemTypeOriginal,
  ItemTypeWithLiterals as ItemTypeWithLiteralsOriginal,
  Section as SectionOriginal,
  SectionItemIds as SectionItemIdsOriginal,
  Menu as MenuOriginal,
  MenuSectionIds as MenuSectionIdsOriginal,
  Discount as DiscountOriginal,
  DiscountValueOneOf as DiscountValueOneOfOriginal,
  DiscountApplyToFilterOneOf as DiscountApplyToFilterOneOfOriginal,
  DiscountType as DiscountTypeOriginal,
  DiscountTypeWithLiterals as DiscountTypeWithLiteralsOriginal,
  SectionIds as SectionIdsOriginal,
  ItemIds as ItemIdsOriginal,
  DiscountCondition as DiscountConditionOriginal,
  DiscountPlatform as DiscountPlatformOriginal,
  DiscountPlatformWithLiterals as DiscountPlatformWithLiteralsOriginal,
  Coupon as CouponOriginal,
  PublishCatalogUpdated as PublishCatalogUpdatedOriginal,
  IndexCacheCmd as IndexCacheCmdOriginal,
  CatalogChanged as CatalogChangedOriginal,
  ListCatalogsRequest as ListCatalogsRequestOriginal,
  Sorting as SortingOriginal,
  SortOrder as SortOrderOriginal,
  SortOrderWithLiterals as SortOrderWithLiteralsOriginal,
  Paging as PagingOriginal,
  ListCatalogsResponse as ListCatalogsResponseOriginal,
  GetMenuRequest as GetMenuRequestOriginal,
  GetMenuResponse as GetMenuResponseOriginal,
  GetSectionRequest as GetSectionRequestOriginal,
  GetSectionResponse as GetSectionResponseOriginal,
  UpdateMenuRequest as UpdateMenuRequestOriginal,
  UpdateMenuResponse as UpdateMenuResponseOriginal,
  V3UpdateSectionRequest as V3UpdateSectionRequestOriginal,
  UpdateSectionResponse as UpdateSectionResponseOriginal,
  ListMenusRequest as ListMenusRequestOriginal,
  ListMenusResponse as ListMenusResponseOriginal,
  ListSectionsRequest as ListSectionsRequestOriginal,
  ListSectionsResponse as ListSectionsResponseOriginal,
  CreateMenuRequest as CreateMenuRequestOriginal,
  CreateMenuResponse as CreateMenuResponseOriginal,
  ArchiveMenuRequest as ArchiveMenuRequestOriginal,
  ArchiveMenuResponse as ArchiveMenuResponseOriginal,
  UnarchiveMenuRequest as UnarchiveMenuRequestOriginal,
  UnarchiveMenuResponse as UnarchiveMenuResponseOriginal,
  ArchiveSectionRequest as ArchiveSectionRequestOriginal,
  ArchiveSectionResponse as ArchiveSectionResponseOriginal,
  RemoveDishFromSectionRequest as RemoveDishFromSectionRequestOriginal,
  RemoveDishFromSectionResponse as RemoveDishFromSectionResponseOriginal,
  V3CreateSectionRequest as V3CreateSectionRequestOriginal,
  CreateSectionResponse as CreateSectionResponseOriginal,
  GetItemRequest as GetItemRequestOriginal,
  GetItemResponse as GetItemResponseOriginal,
  ListItemsRequest as ListItemsRequestOriginal,
  ListItemsResponse as ListItemsResponseOriginal,
  UpdateItemRequest as UpdateItemRequestOriginal,
  UpdateItemResponse as UpdateItemResponseOriginal,
  V3CreateDishRequest as V3CreateDishRequestOriginal,
  CreateDishResponse as CreateDishResponseOriginal,
  CreateVariationRequest as CreateVariationRequestOriginal,
  CreateVariationResponse as CreateVariationResponseOriginal,
  BulkCreateVariationsRequest as BulkCreateVariationsRequestOriginal,
  NewVariation as NewVariationOriginal,
  BulkCreateVariationsResponse as BulkCreateVariationsResponseOriginal,
  BulkItemResult as BulkItemResultOriginal,
  ItemMetadata as ItemMetadataOriginal,
  ApplicationError as ApplicationErrorOriginal,
  BulkActionMetadata as BulkActionMetadataOriginal,
  BulkArchiveMenusRequest as BulkArchiveMenusRequestOriginal,
  BulkArchiveMenusResponse as BulkArchiveMenusResponseOriginal,
  BulkMenuResult as BulkMenuResultOriginal,
  MenuUpdated as MenuUpdatedOriginal,
  Empty as EmptyOriginal,
  BulkCreateDishesRequest as BulkCreateDishesRequestOriginal,
  CreateDishRequest as CreateDishRequestOriginal,
  BulkCreateDishesResponse as BulkCreateDishesResponseOriginal,
  BulkCreateSectionsRequest as BulkCreateSectionsRequestOriginal,
  CreateSectionRequest as CreateSectionRequestOriginal,
  BulkCreateSectionsResponse as BulkCreateSectionsResponseOriginal,
  BulkSectionResult as BulkSectionResultOriginal,
  DomainEvent as DomainEventOriginal,
  DomainEventBodyOneOf as DomainEventBodyOneOfOriginal,
  EntityCreatedEvent as EntityCreatedEventOriginal,
  RestoreInfo as RestoreInfoOriginal,
  EntityUpdatedEvent as EntityUpdatedEventOriginal,
  EntityDeletedEvent as EntityDeletedEventOriginal,
  ActionEvent as ActionEventOriginal,
  MessageEnvelope as MessageEnvelopeOriginal,
  IdentificationData as IdentificationDataOriginal,
  IdentificationDataIdOneOf as IdentificationDataIdOneOfOriginal,
  WebhookIdentityType as WebhookIdentityTypeOriginal,
  WebhookIdentityTypeWithLiterals as WebhookIdentityTypeWithLiteralsOriginal,
  AccountInfo as AccountInfoOriginal,
  CreateDraftCatalogRequest as CreateDraftCatalogRequestOriginal,
  CreateDraftCatalogResponse as CreateDraftCatalogResponseOriginal,
  PublishDraftCatalogRequest as PublishDraftCatalogRequestOriginal,
  PublishDraftCatalogResponse as PublishDraftCatalogResponseOriginal,
  DiscardDraftCatalogRequest as DiscardDraftCatalogRequestOriginal,
  DiscardDraftCatalogResponse as DiscardDraftCatalogResponseOriginal,
  BulkUpdateItemsRequest as BulkUpdateItemsRequestOriginal,
  BulkUpdateItemsResponse as BulkUpdateItemsResponseOriginal,
  BulkCreateMenusRequest as BulkCreateMenusRequestOriginal,
  BulkCreateMenusResponse as BulkCreateMenusResponseOriginal,
  BulkUpdateMenusRequest as BulkUpdateMenusRequestOriginal,
  BulkUpdateMenusResponse as BulkUpdateMenusResponseOriginal,
  BulkUpdateSectionsRequest as BulkUpdateSectionsRequestOriginal,
  UpdateSectionRequest as UpdateSectionRequestOriginal,
  BulkUpdateSectionsResponse as BulkUpdateSectionsResponseOriginal,
  BulkUnarchiveMenusRequest as BulkUnarchiveMenusRequestOriginal,
  BulkUnarchiveMenusResponse as BulkUnarchiveMenusResponseOriginal,
} from './restaurants-catalogs-v3-catalog-catalogs.types.js';
